import { render, staticRenderFns } from "./AlliancesModuleComponent.vue?vue&type=template&id=41bd5dde&scoped=true&"
import script from "./AlliancesModuleComponent.vue?vue&type=script&lang=js&"
export * from "./AlliancesModuleComponent.vue?vue&type=script&lang=js&"
import style0 from "./AlliancesModuleComponent.vue?vue&type=style&index=0&id=41bd5dde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41bd5dde",
  null
  
)

export default component.exports